import {Modal} from 'react-bootstrap'
import {connect} from 'react-redux'
import * as actConfirmAction from 'actions/confirm-action'
import styles from './ConfirmActionModal.css'

class ConfirmActionModal extends React.Component {
  render () {
    let {showConfirmActionModal} = this.props.data.confirmAction
    return (<Modal onHide={this._onHide} show={showConfirmActionModal} dialogClassName={`${styles.dialog} modal-dialog`}>
      <Modal.Header>
        <Modal.Title className={styles['title-modal']}>Information</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>Are you sure you want to leave screen and discard your changes ?
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button type='button' className='btn btn-default' onClick={this._onHide}>
            Cancel
          </button>
          <button type='button' className='btn btn-primary' onClick={this._onConfirm}>
            Ok
          </button>
        </div>
      </Modal.Footer>
    </Modal>)
  }

  _onHide = () => {
    this.props.dispatch(actConfirmAction.cancelAction())
  }

  _onConfirm = () => {
    let {nextAction} = this.props.data.confirmAction
    this.props.dispatch(actConfirmAction.confirmAction(nextAction))
  }
}

function mapStateToProps (state) {
  return {
    data: {
      confirmAction: state.confirmAction
    }
  }
}
export default connect(mapStateToProps)(ConfirmActionModal)



// WEBPACK FOOTER //
// ./app/components/ConfirmActionModal/ConfirmActionModal.js